<template>
  <v-hover v-slot="{ hover }">
    <v-card
      outlined
      class="rounded-xl pa-3 transition-swing d-flex flex-column justify-space-between fill-height w-100 folder-box"
      :class="{ 'folder-box--hovered': hover }"
      @click="handleOpen"
    >
      <div>
        <!-- بخش بالایی: آیکون پوشه و تعداد کیوآر -->
        <div class="d-flex align-center justify-space-between mb-3">
          <v-chip
            x-small
            color="amber lighten-5"
            text-color="amber darken-4"
            class="px-2 py-1 font-weight-bold rounded-lg chip-badge"
          >
            <v-icon x-small left color="amber darken-3">mdi-qrcode-scan</v-icon>
            {{ totalItemsCount }} عدد کیوآر
          </v-chip>

          <div class="folder-icon-wrapper">
            <v-icon
              size="44"
              :color="hover ? 'amber darken-1' : 'amber darken-2'"
              class="folder-icon"
            >
              {{ hover ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
          </div>
        </div>

        <!-- عنوان و ویرایش نام -->
        <div class="d-flex align-center justify-space-between mt-1">
          <v-btn
            icon
            x-small
            color="grey darken-1"
            class="edit-btn"
            @click.stop="$emit('edit-name', currentGroup)"
            title="ویرایش نام"
          >
            <v-icon x-small>mdi-pencil-outline</v-icon>
          </v-btn>

          <span
            class="font-weight-bold text-subtitle-2 grey--text text--darken-3 text-truncate flex-grow-1 text-right pr-1"
            :title="computedDisplayName"
          >
            {{ computedDisplayName }}
          </span>
        </div>
      </div>

      <!-- دکمه‌های عملیاتی پایین کارت -->
      <div class="mt-4 pt-2 border-top" @click.stop>
        <div class="d-flex align-center justify-space-between flex-wrap ga-1">
          <!-- دانلود -->
          <v-btn
            x-small
            outlined
            color="success"
            class="rounded-lg font-weight-bold my-1"
            :loading="isDownloading"
            @click="$emit('export-group', currentGroup)"
            title="دانلود کامل"
          >
            <v-icon x-small>mdi-download-outline</v-icon>
          </v-btn>

          <!-- انتقال خرید -->
          <v-btn
            x-small
            outlined
            color="warning"
            class="rounded-lg font-weight-bold my-1"
            @click="$emit('transfer-group', availableItems)"
            :title="`انتقال خرید (${availableItemsCount})`"
          >
            <v-icon x-small>mdi-account-arrow-right</v-icon>
          </v-btn>

          <!-- انتقال پیش‌خرید -->
          <v-btn
            x-small
            outlined
            color="info"
            class="rounded-lg font-weight-bold my-1"
            @click="$emit('transfer-user-group', availableItems)"
            :title="`انتقال پیش خرید (${availableItemsCount})`"
          >
            <v-icon x-small>mdi-account-arrow-left</v-icon>
          </v-btn>

          <!-- ورود به پوشه -->
          <v-btn
            small
            icon
            color="amber darken-2"
            class="open-arrow-btn my-1"
            @click="handleOpen"
            title="باز کردن پوشه"
          >
            <v-icon small>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "FolderCard",
  props: {
    group: { type: Object, default: () => ({}) },
    folder: { type: Object, default: () => ({}) },
    displayName: { type: String, default: "" },
    folderName: { type: String, default: "" },
    isDownloading: { type: Boolean, default: false },
  },
  computed: {
    currentGroup() {
      return this.group || this.folder || {};
    },
    rawFolderName() {
      return (
        this.folderName ||
        this.currentGroup.folder_name ||
        this.currentGroup.name ||
        this.currentGroup.key ||
        "-"
      );
    },
    computedDisplayName() {
      return (
        this.displayName ||
        this.currentGroup.title ||
        this.currentGroup.display_name ||
        this.rawFolderName
      );
    },
    totalItemsCount() {
      if (typeof this.currentGroup.total_items !== "undefined") return Number(this.currentGroup.total_items);
      if (typeof this.currentGroup.total !== "undefined") return Number(this.currentGroup.total);
      if (Array.isArray(this.currentGroup.items)) return this.currentGroup.items.length;
      return 0;
    },
    availableItems() {
      if (!Array.isArray(this.currentGroup.items)) return [];
      return this.currentGroup.items.filter(item => item && item.status === "available");
    },
    availableItemsCount() {
      return this.availableItems.length || this.totalItemsCount;
    }
  },
  methods: {
    handleOpen() {
      this.$emit("open", this.currentGroup);
    },
  },
};
</script>

<style scoped>
.folder-box {
  cursor: pointer;
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  min-height: 160px; /* جلوگیری از collapse شدن کارت */
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.folder-box--hovered {
  border-color: #f59e0b !important;
  box-shadow: 0 8px 20px -4px rgba(245, 158, 11, 0.18) !important;
  transform: translateY(-3px);
}
.border-top {
  border-top: 1px dashed #edf2f7;
}
</style>
